import ApiService from '@/services/ApiService';

class WhatsAppService {
  static async getWhatsAppSlots() {
    const composedURL = '/api3/tokko_chat/whatsapp/slots';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getAvailableSlot() {
    const composedURL = '/api3/tokko_chat/whatsapp/slots/assignments/available';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getSlotsAvailability() {
    const composedURL = '/api3/tokko_chat/whatsapp/slots/availability';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getWhatsAppSlot(slotId) {
    const composedURL = `/api3/tokko_chat/whatsapp/slots/${slotId}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getAvailableBranches() {
    const composedURL = '/api3/tokko_chat/whatsapp/slots/availables/branches';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getAvailableAgents() {
    const composedURL = '/api3/tokko_chat/whatsapp/slots/availables/agents';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async createWhatsAppSlot(slotData) {
    const composedURL = '/api3/tokko_chat/whatsapp/slots';
    const response = await ApiService.post(composedURL, slotData);
    return response;
  }

  static async assignWhatsAppSlot(slotData) {
    const { slot_id, ...dataToSend } = slotData;
    const composedURL = `/api3/tokko_chat/whatsapp/slots/${slot_id}/assignments`;
    const response = await ApiService.post(composedURL, dataToSend);
    return response;
  }

  static async unassignWhatsAppSlot(slotId) {
    const composedURL = `/api3/tokko_chat/whatsapp/slots/${slotId}/assignments`;
    // const composedURL = `/api3/tokko_chat/whatsapp/slots/${slotId}`;
    const response = await ApiService.put(composedURL);
    return response;
  }

  static async getWhatsAppQRCode(slotId) {
    const composedURL = `/api3/tokko_chat/whatsapp/slots/${slotId}/qrcode`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async linkCloudApiNumber({ slotId, phoneNumber }) {
    const composedURL = `/api3/tokko_chat/whatsapp/slots/${slotId}/instance`;
    const response = await ApiService.post(composedURL, {
      phone_number: phoneNumber,
    });
    return response;
  }

  static async unlinkWhatsAppSlot(slotId) {
    const composedURL = `/api3/tokko_chat/whatsapp/slots/${slotId}/instance`;
    const response = await ApiService.delete(composedURL);
    return response;
  }

  static async getWebSocketAccessToken() {
    const tokkoChatHost = localStorage.getItem('tokkoChatHost');
    const composedURL = `${tokkoChatHost}/authorize/oauth`;
    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('jwt'),
      },
    };

    const response = await fetch(composedURL, requestOptions);
    if (!response.ok) {
      throw new Error(response.message || 'Request failed');
    }

    const data = await response.json();
    return data;
  }
}

export default WhatsAppService;
